import { ContactComponent } from './contact/contact.component';
import { CompleteDataGeneralComponent } from './admin/users/complete-data-general/complete-data-general.component';
import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';

import { EnsureAuthenticatedService } from './services/ensure-authenticated.service';
import { LoginRedirectService } from './services/login-redirect.service';
import {LoginComponent} from './auth/login/login.component';
import {InvoiceReceptionComponent} from './receptions/invoice-reception/invoice-reception.component';
import {OpenOrdersComponent} from './orders/open-orders/open-orders.component';
import {CloseOrdersComponent} from './orders/close-orders/close-orders.component';
import {InvoicesReportComponent} from './reports/invoices-report/invoices-report.component';
import {OrdersReportComponent} from './reports/orders-report/orders-report.component';
import {PaymentsReportComponent} from './reports/payments-report/payments-report.component';
import {FaqsComponent} from './help/faqs/faqs.component';
import {ManualUserComponent} from './help/manual-user/manual-user.component';
import {HomeComponent} from './home/home.component';
import {ModalConfirmComponent} from './modal-confirm/modal-confirm.component';
import {ModalDetailComponent} from './modal-detail/modal-detail.component';
import {UsersComponent} from './admin/users/users/users.component';
import {ProvidersComponent} from './admin/providers/providers/providers.component';
import {WorkflowComponent} from './admin/workflow/workflow/workflow.component';
import {CompaniesComponent} from './admin/companies/companies/companies.component';
import {GeneralComponent} from './admin/general/general/general.component';
import {ProviderComponent} from './admin/providers/provider/provider.component';
import {ProviderDetailComponent} from './admin/providers/provider-detail/provider-detail.component';
import {UserComponent} from './admin/users/user/user.component';
import {CompanyComponent} from './admin/companies/company/company.component';
import {WorkflowsComponent} from './admin/workflow/workflows/workflows.component';
import {WorkflowDetailComponent} from './admin/workflow/workflow-detail/workflow-detail.component';
import {OfficesComponent} from './admin/offices/offices/offices.component';
import {OfficeComponent} from './admin/offices/office/office.component';
import {DepartamentsComponent} from './admin/departaments/departaments/departaments.component';
import {DepartamentComponent} from './admin/departaments/departament/departament.component';
import {SystemComponent} from './system/system/system.component';
import {ConsignmentsComponent} from './consignment/consignments/consignments.component';
import {ServicesComponent} from './service/services/services.component';
import {ApproverServicesComponent} from './service/approver-services/approver-services.component';
import {ApproverServicesDetailComponent} from './service/approver-services-detail/approver-services-detail.component';
import {ModalInvoicePdfComponent} from './modal-invoice-pdf/modal-invoice-pdf.component';
import {ComplementPaymentsComponent} from './payments/complement-payments/complement-payments.component';
import {ManualPaymentsComponent} from './payments/manual-payments/manual-payments.component';
import {InvoicesPaymentsComponent} from './payments/invoices-payments/invoices-payments.component';
import {ComplementPaymentsDetailComponent} from './payments/complement-payments-detail/complement-payments-detail.component';
import {ComplementHistoryComponent} from './payments/complement-history/complement-history.component';
import {ModalUploadComponent} from './modal-upload/modal-upload.component';
import {CloseOrdersListComponent} from './orders/close-orders-list/close-orders-list.component';
import {CloseOrdersListReportComponent} from './orders/close-orders-list-report/close-orders-list-report.component';
import {OpenOrdersListComponent} from './orders/open-orders-list/open-orders-list.component';
import {ServicesListComponent} from './service/services-list/services-list.component';
import {OrderDetailComponent} from './orders/order-detail/order-detail.component';
import {CreditNoteComponent} from './credit-notes/credit-note/credit-note.component';
import {UserDetailComponent} from './admin/users/user-detail/user-detail.component';
import {ManualComponent} from './admin/general/manuales/manual.component';
import {ProviderModalComponent} from './admin/providers/provider-modal/provider-modal.component';
import {AuthorizersComponent} from './admin/authorizers/authorizers/authorizers.component';
import {AuthorizersDetailComponent} from './admin/authorizers/authorizers-detail/authorizers-detail.component';
import {RetentionsComponent} from './service/retentions/retentions.component';
import {RetentionsDetailComponent} from './service/retentions-detail/retentions-detail.component';
import {CostCenterComponent} from './admin/cost-center/cost-center.component';
import {CostCenterDetailComponent} from './admin/cost-center-detail/cost-center-detail.component';
import { ModalErrorPaymentComponent } from './payments/modal-error-payment/modal-error-payment.component';
import { RecoverComponent } from './auth/recover/recover.component';
import { ComunicadosComponent } from './admin/comunicados/comunicados.component';
import { ModalComunicadoComponent } from './modal-comunicado/modal-comunicado.component';
import { PoliticasComponent } from './admin/general/politicas/politicas.component';
import { BulkLoadComponent } from './payments/bulk-load/bulk-load.component';
import { ModalBulkLoadComponent } from './modal-bulk-load/modal-bulk-load.component';
import { NoteListComponent } from './credit-notes/note-list/note-list.component';
import { NoteSearchComponent } from './credit-notes/note-search/note-search.component';
import { ManualListComponent } from './manual-payments/manual-list/manual-list.component';
import { ManualSearchComponent } from './manual-payments/manual-search/manual-search.component';
import { ApproveComponent } from './orders/approve-orders/approve.component';
import { ReportConsigmentsComponent } from './consignment/report-consigments/report-consigments.component';
import { ModalComunicadosShowComponent } from './admin/comunicados-show/comunicados-show';

export const AppRoutes: Routes = [
  { path: 'login', component: LoginComponent,  },
  {
    path: 'informacion-general', component: CompleteDataGeneralComponent,
  },
  {
    path: 'registrar-comunicado', component: ModalComunicadoComponent,
  },
  {
    path: 'visualizar-comunicado', component: ModalComunicadosShowComponent,
  },
  {
    path: 'nuevaCargaMasiva', component: ModalBulkLoadComponent
  },
  {
    path: 'resetPassword/:token/:usuario', component: RecoverComponent
  },
  {
    path: 'politicas', component: PoliticasComponent
  },
  {
    path: 'contactSmp', component: ContactComponent,
  },
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
    {
      path: 'contact', component: ContactComponent,
    },
    { path: 'comunicados', component: ComunicadosComponent},
    { path: 'admin',
      children: [
        { path: 'usuarios', component: UsersComponent},
        { path: 'usuario', component: UserComponent},
        { path: 'proveedores', component: ProvidersComponent},
        { path: 'proveedor', component: ProviderComponent },
        { path: 'proveedor/:id', component: ProviderComponent },
        { path: 'proveedor-info', component: ProviderModalComponent },
        { path: 'workflows', component: WorkflowsComponent},
        { path: 'workflow', component: WorkflowComponent},
        { path: 'workflow/:id', component: WorkflowComponent},
        { path: 'workflow/detail', component: WorkflowDetailComponent},
        { path: 'empresas', component: CompaniesComponent},
        { path: 'empresa', component: CompanyComponent},
        { path: 'sucursales', component: OfficesComponent},
        { path: 'sucursal', component: OfficeComponent},
        { path: 'departamentos', component: DepartamentsComponent},
        { path: 'departamento', component: DepartamentComponent},
        { path: 'general', component: GeneralComponent},
        { path: 'admin-auth', component: AuthorizersComponent},
        { path: 'admin-auth-detail', component: AuthorizersDetailComponent},
        { path: 'centro-costos', component: CostCenterComponent},
        { path: 'orden-interno', component: CostCenterComponent},
        { path: 'centro-costos-detalle', component: CostCenterDetailComponent}

      ]
    },
    { path: 'recepciones',
      children: [{
        path: 'facturas',
        component: InvoiceReceptionComponent
      }]
    },
    {
      path: 'ordenes-abiertas',
      children: [{
        path: 'lista',
        component: OpenOrdersListComponent
      },
      {

        path: 'lista/:guid',
        component: OpenOrdersListComponent,
      },
      {
        path: 'buscar',
        component: OpenOrdersComponent
      }]
    },
    {
      path: 'ordenes-cerradas',
      children: [{
        path: 'lista',
        component: CloseOrdersListComponent
      },
      {
        path: 'lista/:guid',
        component: CloseOrdersListComponent,
      },
      {
        path: 'buscar',
        component: CloseOrdersComponent
      },
      {
        path: 'aprobar',
        component: ApproveComponent
      },

    ]
    },

    {
      path: 'aprobar-ordenes',
      children:
      [{
        path: 'aprobar-cerradas/:idTipo',
        component: ApproveComponent
      },
      {
        path: 'aprobar-abiertas/:idTipo',
        component: ApproveComponent
      }]
    },


    { path: 'servicios',
      children: [{
        path: 'lista',
        component: ServicesListComponent
      },{
        path: 'buscar',
        component: ServicesComponent
      },{
        path: 'retenciones',
        component: RetentionsComponent
      },{
        path: 'retenciones-detalle',
        component: RetentionsDetailComponent
      },{
        path: 'aprobar',
        component: ApproverServicesComponent
      }]
    },
    { path: 'inicio', component: HomeComponent },
    { path: 'mi-perfil', component: UserDetailComponent },
    { path: 'manuales', component: ManualComponent },
    { path: 'sistema', component: SystemComponent },
    { path: 'consignacion',
        children: [{
          path: 'carga',
          component: ConsignmentsComponent
        },{
          path: 'reporte',
          component: ReportConsigmentsComponent
        }
      ]
   },

    { path: 'aprobar-servicios', component: ApproverServicesComponent },
    { path: 'aprobar-servicio', component: ApproverServicesDetailComponent },
    { path: 'facturas-pagos', component: InvoicesPaymentsComponent },
    { path: 'pagos-manuales',
        children: [{
          path: 'Listado',
          component: ManualListComponent
        },
        {
          path: 'Listado/:guid',
          component: ManualListComponent
        },
        {
          path: 'buscar',
          //component: ManualSearchComponent
          component: ManualPaymentsComponent
        }
      ]
    },
    { path: 'notas-credito',
        children: [{
          path: 'Listado',
          component: NoteListComponent
        },{
          path: 'Buscar',
          //component: NoteSearchComponent
          component: CreditNoteComponent
        }
      ]
    },
    { path: 'complementos-pagos',
      children: [{
        path: 'carga',
        component: ComplementPaymentsComponent
      },{
        path: 'historial',
        component: ComplementHistoryComponent
      },{
        path: 'pagos',
        component: PaymentsReportComponent
      },
      {
        path: 'cargaMasiva', component: BulkLoadComponent
      }]
    },
    { path: 'complementos-detalle',
      component: ComplementPaymentsDetailComponent
    },
    { path: 'reportes',
      children: [{
        path: 'facturas',
        component: InvoicesReportComponent
      },{
        path: 'ordenes',
        component: OrdersReportComponent
      },
      {
        path: 'conciliacion',
        component: CloseOrdersListReportComponent
      }
    ]
    },
    { path: 'ayuda',
      children: [{
        path: 'faqs',
        component: FaqsComponent
      },{
        path: 'manual',
        component: ManualUserComponent
      }]
    },
    { path: 'deleteModal', component: ModalConfirmComponent },
    { path: 'detailModal', component: ModalDetailComponent},
    { path: 'uploadModal', component: ModalUploadComponent},
    { path: 'invoicePdf', component: ModalInvoicePdfComponent},
    { path: 'errorComplemetPayment', component: ModalErrorPaymentComponent},
    { path: 'orderDetail', component: OrderDetailComponent}],
   // canActivate: [EnsureAuthenticatedService]
  }
];
